export const getWeeks = (date: number) => {
    const oneWeek = 1000 * 60 * 60 * 24 * 7;
    return date && Math.floor(date / oneWeek) || 0;
}
